/**
 * Parse quiz timer end from API (IST wall time or ISO).
 * @param {string|Date|null} value
 * @returns {number|null} epoch ms
 */
export function parseQuizTimerEndMs(value) {
    if (value == null || value === '') return null;
    if (value instanceof Date) {
        const ms = value.getTime();
        return Number.isFinite(ms) ? ms : null;
    }
    const raw = String(value).trim();
    if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}$/.test(raw)) {
        const ms = new Date(`${raw.replace(' ', 'T')}+05:30`).getTime();
        return Number.isFinite(ms) ? ms : null;
    }
    const ms = new Date(raw).getTime();
    return Number.isFinite(ms) ? ms : null;
}

/**
 * @param {string|Date|null} timerEnd
 * @returns {number|null} seconds remaining
 */
export function computeQuizTimeLeftSeconds(timerEnd) {
    const endMs = parseQuizTimerEndMs(timerEnd);
    if (endMs == null) return null;
    return Math.max(0, Math.round((endMs - Date.now()) / 1000));
}

export function isQuizTimerActive(session) {
    return Boolean(session && session.current_question_status === 'timer_active');
}

/** Match server: open while faculty status is timer_active (clock skew handled server-side). */
export function canSubmitQuizAnswer(session, { canSubmitAnswer } = {}) {
    if (typeof canSubmitAnswer === 'boolean') return canSubmitAnswer;
    return isQuizTimerActive(session);
}
